import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-star\">\n<path fill-rule=\"evenodd\" d=\"M-0.000,4.860 L5.154,4.860 L6.873,0.110 L8.345,4.860 L13.500,4.860 L9.327,8.111 L10.800,13.110 L6.627,10.111 L2.700,13.110 L3.927,7.861 L-0.000,4.860 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol